import React from "react";
import { X } from "lucide-react";
import { DesignGallery } from "./DesignGallery";

/** Lightweight design selector used from /tempah. Never resets form data. */
export const DesignPickerModal = ({ open, templates, selectedId, onSelect, onClose }) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[60] flex items-end sm:items-center justify-center"
      role="dialog"
      aria-modal="true"
      aria-label="Tukar design kad"
      data-testid="design-picker-modal"
    >
      <button
        type="button"
        aria-label="Tutup"
        onClick={onClose}
        className="absolute inset-0 bg-[#0b2a20]/55 backdrop-blur-[2px]"
        data-testid="design-picker-backdrop"
      />
      <div className="relative w-full sm:max-w-4xl max-h-[88vh] overflow-y-auto rounded-t-3xl sm:rounded-3xl bg-[#fbfaf6] border border-[#0f3f2f]/12 shadow-2xl">
        <div className="sticky top-0 flex items-center justify-between gap-4 bg-[#fbfaf6]/95 backdrop-blur px-5 sm:px-7 py-4 border-b border-[#0f3f2f]/10">
          <div>
            <p className="t-label">Tukar Design</p>
            <h2 className="t-h2">Pilih design lain</h2>
          </div>
          <button
            type="button"
            onClick={onClose}
            data-testid="btn-tutup-design-picker"
            className="grid place-items-center h-10 w-10 rounded-xl border border-[#0f3f2f]/15 text-[#0f3f2f] hover:bg-white transition-colors duration-200"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="px-5 sm:px-7 py-6">
          <p className="t-help mb-5">Maklumat yang telah anda isi akan dikekalkan.</p>
          <DesignGallery
            templates={templates}
            selectedId={selectedId}
            onSelect={onSelect}
            compact
            idPrefix="modal-"
          />
        </div>
      </div>
    </div>
  );
};
